import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "taTruncate",
  pure: true
})
export class TruncationPipe implements PipeTransform {
  transform(value: string, totalNumCharacters: number): string {
    if (value == null || value.length <= totalNumCharacters) {
      return value;
    }

    return this.truncate(value, totalNumCharacters);
  }

  private truncate(value: string, totalNumCharacters: number): string {
    return value.substr(0, totalNumCharacters - 1) + "…";
  }
}
